module.exports = __webpack_public_path__ + "img/ssbg5.1dab00e1.jpg";